<article class="item">
    <div class="avatar-wrapper">
        <div class="avatar">
            <app-image *ngIf="storePhoto" [image]="storePhoto" [height]="64" [width]="64"></app-image>
            <app-svg-icon *ngIf="!storePhoto" iconName="favicon"></app-svg-icon>
        </div>
    </div>

    <section class="content">
        <div class="description">
            <h6 class="text-semibold">{{ store.storeName }}</h6>
            <span>{{ store.address }}</span>
            <span>{{ store.postalCode }} {{ store.city }}</span>
            <span>{{ 'stores.labels.phone' | translateSafe }} {{ store.phone }}</span>
        </div>

        <div class="schedule" *ngIf="store.openingTimes && store?.openingTimes?.length">
            <div class="item-today">
                {{
                    store.openingTimes[0].isClosed
                        ? ('stores.labels.closedToday' | translateSafe)
                        : ('stores.labels.openToday' | translateSafe)
                }}
            </div>

            <div class="time" *ngIf="!store.openingTimes[0].isClosed">
                {{ openingTime.openFromDateTime | date : 'HH.mm' }} - {{ openingTime.openToDateTime | date : 'HH.mm' }}
            </div>
        </div>

        <app-arrow-link
            *ngIf="store"
            [link]="{ url: store.storeUrl }"
            (linkClick)="this.gtmService.trackGoToStore(store.storeName || '')"
        >
            {{ 'stores.link.goToStore' | translateSafe }}
        </app-arrow-link>
    </section>
</article>
